import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';
import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import FormInputComponent from 'webapp/components/form/input';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';
import ZapsListComponent from 'webapp/components/zaps-list';

export default class SourceWrapperForPopupTemplatesComponent extends PopupInnerModalComponent<PopupData.Source.WrapperForTemplates> {
	@service('account') declare accountService: Service.Account;

	get token() {
		return this.popupData.token;
	}

	get sourceType() {
		return this.popupData.sourceType;
	}

	get companyName(): string {
		return this.accountService.shownCompanyName;
	}

	get isEmbedListShown(): boolean {
		return !this.accountService.hideDataboxNotWhiteLabeledContentForNonAdmins;
	}

	@action
	connectSource(): void {
		void this.sourceType.connectNew();
	}

	@action
	bindInputEvents(node: HTMLElement) {
		const inputNode = node as HTMLInputElement;
		['focus', 'click'].forEach((eventName) => {
			inputNode.addEventListener(eventName, () => {
				inputNode.select();
			});
		});
		inputNode.select();
	}
	<template>
		<div class="content">
			<h3>New {{this.sourceType.name}} data source</h3>

			{{#if this.token}}
				<div class="token">
					<CommonUiIconComponent @name="Check" @size="lg" class="token-check" />
					<span>
						{{this.sourceType.name}}
						will need this token to access your
						{{this.companyName}}
						account:
					</span>
					<FormInputComponent
						name="token"
						@value={{this.token}}
						readonly={{true}}
						{{didInsert this.bindInputEvents}}
					/>
				</div>
			{{else}}
				<div class="no-token">
					<p>Create a pushable {{this.sourceType.name}} token in Databox.</p>
					<SubmitButtonComponent
						@text="New token"
						@icon="External"
						@noDelay={{true}}
						@onTrigger={{this.connectSource}}
					/>
				</div>
			{{/if}}

			{{#if this.isEmbedListShown}}
				<div class="list-wrapper">
					{{#if this.sourceType.isZapier}}
						<strong>Our recommended Zaps</strong>
						<ZapsListComponent />
					{{/if}}
				</div>
			{{/if}}
		</div>
	</template>
}
